module.exports = __webpack_public_path__ + "static/img/jacket2_tr.1ce60236.png";